import { Accordion } from '@mui/material';
import React, { useState } from 'react';

export const CustomAccordion = ({
    children,
    initialExpanded = true
}: {
    children: NonNullable<React.ReactNode>;
    initialExpanded?: boolean;
}) => {
    const [expanded, setExpanded] = useState(initialExpanded);
    return (
        <Accordion
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
            slotProps={{ transition: { unmountOnExit: true } }}
            disableGutters
            sx={{
                marginBottom: '16px'
            }}
        >
            {children}
        </Accordion>
    );
};
